<script>
import SignaturePadLib from "signature_pad";

export default {
  name: "SignaturePad",
  props: {
    title: { type: String, default: "" },
  },
  emits: ["confirm", "cancel"],
  data() {
    return { isEmpty: true };
  },
  mounted() {
    // setTimeout necessario: VueFinalModal applica la transizione CSS dopo il mount,
    // quindi offsetWidth è 0 al momento del mount e anche dopo $nextTick.
    setTimeout(() => {
      const canvas = this.$refs.canvas;
      if (!canvas) return;
      this._resizeCanvas(canvas);
      this._pad = new SignaturePadLib(canvas, {
        backgroundColor: "rgba(0,0,0,0)",
      });
      this._pad.addEventListener("beginStroke", () => {
        this.isEmpty = false;
      });
      this._onResize = () => {
        const data = this._pad.toData();
        this._resizeCanvas(canvas);
        this._pad.fromData(data);
      };
      window.addEventListener("resize", this._onResize);
    }, 150);
  },
  beforeUnmount() {
    this._pad?.off();
    window.removeEventListener("resize", this._onResize);
  },
  methods: {
    _resizeCanvas(canvas) {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      const w = canvas.offsetWidth || 400;
      const h = canvas.offsetHeight || 180;
      canvas.width = w * ratio;
      canvas.height = h * ratio;
      canvas.getContext("2d").scale(ratio, ratio);
    },
    clear() {
      this._pad?.clear();
      this.isEmpty = true;
    },
    confirm() {
      if (!this._pad || this._pad.isEmpty()) return;
      this.$emit("confirm", this._pad.toDataURL("image/png"));
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<template>
  <div class="sig-pad">
    <h3 class="sig-pad__title">Firma documento</h3>
    <p v-if="title" class="sig-pad__doc-name">{{ title }}</p>
    <canvas ref="canvas" class="sig-pad__canvas"></canvas>
    <div class="sig-pad__actions">
      <button
        class="sig-pad__btn sig-pad__btn--clear"
        type="button"
        @click="clear"
      >
        Cancella
      </button>
      <button
        class="sig-pad__btn sig-pad__btn--cancel"
        type="button"
        @click="cancel"
      >
        Annulla
      </button>
      <button
        class="sig-pad__btn sig-pad__btn--confirm"
        type="button"
        :disabled="isEmpty"
        @click="confirm"
      >
        Conferma firma
      </button>
    </div>
  </div>
</template>

<style scoped>
.sig-pad {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 480px;
  width: 100%;
}

.sig-pad__title {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0;
}

.sig-pad__doc-name {
  font-size: 0.85rem;
  color: #555;
  margin: 0;
  word-break: break-all;
}

.sig-pad__canvas {
  border: 2px solid #9ec44a;
  border-radius: 4px;
  width: 100%;
  height: 180px;
  touch-action: none;
  cursor: crosshair;
  background: #fff;
}

.sig-pad__actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.sig-pad__btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
}

.sig-pad__btn--clear {
  background: #f0f0f0;
  color: #333;
}

.sig-pad__btn--cancel {
  background: #eee;
  color: #333;
}

.sig-pad__btn--confirm {
  background: #000;
  color: #9ec44a;
}

.sig-pad__btn--confirm:disabled {
  background: #ccc;
  color: #888;
  cursor: not-allowed;
}
</style>
